import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  positionGroupLevels: [],
  filterPositionGroup: [],
  filterActive: [],
  loadingStates: []
}

const fetchPositionGroupStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchPositionGroupSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })

  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: action.pagination,
    records
  }
}

const fetchPositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    errorMessage: action.errorMessage
  }
}

const fetchPositionGroupByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedPositionGroupRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createPositionGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const createPositionGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createPositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updatePositionGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const updatePositionGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updatePositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deletePositionGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const deletePositionGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deletePositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchFilterPositionGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchFilterPositionGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    filterPositionGroup: action.data
  }
}

const fetchFilterPositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchPositionGroupLevelOptionsStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'position_level_group_id']
  }
}

const fetchPositionGroupLevelOptionsSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_level_group_id'),
    positionGroupLevels: action.data
  }
}

const fetchPositionGroupLevelOptionsFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_level_group_id')
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_POSITION_GROUP_START:
      return fetchPositionGroupStart(state, action)
    case actionTypes.FETCH_POSITION_GROUP_SUCCESS:
      return fetchPositionGroupSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_BY_ID_SUCCESS:
      return fetchPositionGroupByIdSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_FAILED:
      return fetchPositionGroupFailed(state, action)
    case actionTypes.CLEAR_SELECTED_POSITION_GROUP_RECORD:
      return clearSelectedPositionGroupRecord(state, action)
    case actionTypes.CREATE_POSITION_GROUP_START:
      return createPositionGroupStart(state, action)
    case actionTypes.CREATE_POSITION_GROUP_SUCCESS:
      return createPositionGroupSuccess(state, action)
    case actionTypes.CREATE_POSITION_GROUP_FAILED:
      return createPositionGroupFailed(state, action)
    case actionTypes.UPDATE_POSITION_GROUP_START:
      return updatePositionGroupStart(state, action)
    case actionTypes.UPDATE_POSITION_GROUP_SUCCESS:
      return updatePositionGroupSuccess(state, action)
    case actionTypes.UPDATE_POSITION_GROUP_FAILED:
      return updatePositionGroupFailed(state, action)
    case actionTypes.DELETE_POSITION_GROUP_START:
      return deletePositionGroupStart(state, action)
    case actionTypes.DELETE_POSITION_GROUP_SUCCESS:
      return deletePositionGroupSuccess(state, action)
    case actionTypes.DELETE_POSITION_GROUP_FAILED:
      return deletePositionGroupFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)

    case actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_START:
      return fetchPositionGroupLevelOptionsStart(state, action)
    case actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_SUCCESS:
      return fetchPositionGroupLevelOptionsSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_FAILED:
      return fetchPositionGroupLevelOptionsFailed(state, action)

    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_START:
      return fetchFilterPositionGroupStart(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_SUCCESS:
      return fetchFilterPositionGroupSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_FAILED:
      return fetchFilterPositionGroupFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
